import { type CheckboxOptionType } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type RangeAmount } from '../../../../../api';
import { roundUpWithPrecision } from '../../../../../utilities/rounding';
import useCompanyFormats from '../../../../../utilities/useCompanyFormats';
import FilterGroup from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/FilterGroup';
import { useCarListingState } from '../CarListingStateProvider';

export const rangeToString = (range: RangeAmount) => `${Math.floor(range.from)}-${Math.ceil(range.to)}`;

const MonthlyPaymentFilter = () => {
    const { t } = useTranslation(['carList']);
    const {
        state: { filters, rangeMonthlyPaymentFilter },
        actions,
    } = useCarListingState();

    const { currencySymbol, amountDecimals, formatAmount } = useCompanyFormats();

    const options: CheckboxOptionType[] = useMemo(
        () =>
            filters?.monthlyInstalments.map(monthly => ({
                label: t('carList:filter.dailyRate', {
                    currency: currencySymbol,
                    from: formatAmount(roundUpWithPrecision(monthly.from, amountDecimals)),
                    to: formatAmount(roundUpWithPrecision(monthly.to, amountDecimals)),
                }),
                value: rangeToString(monthly),
            })),
        [currencySymbol, filters?.monthlyInstalments, formatAmount, t]
    );

    const onChange = useCallback(
        (value: string[]) => {
            actions.setPage(1);
            actions.setScroll(false);
            actions.setRangeMonthlyPaymentFilter(value.length > 0 ? value : []);
        },
        [actions]
    );

    if (!options?.length || options.length === 1) {
        return null;
    }

    return (
        <FilterGroup
            onChange={onChange}
            options={options}
            title={t('carList:filter.monthlyPaymentTitle')}
            value={rangeMonthlyPaymentFilter || []}
        />
    );
};

export default MonthlyPaymentFilter;
